// extracted by mini-css-extract-plugin
module.exports = {"phoneTop":"PhoneTop_phoneTop__CgoAz","title":"PhoneTop_title__rbsnc"};